import { apiPostAuth, apiPostMultipartAuth } from '@/utils/api'
import { API_AUTOMATION_REPORT, PREVIEW_AUTOMATION_REPORT } from '@/utils/api-url'
const state = {
  isLoading: false
}

const getters = {
  isLoading(state) {
    return state.isLoading
  }
}

const actions = {
  getTopSpenderPreview({ commit }, payload) {
    commit('SET_IS_LOADING', true)
    return new Promise((resolve, reject) => {
      apiPostAuth(PREVIEW_AUTOMATION_REPORT.TOP_SPENDER, payload)
        .then((response) => {
          commit('SET_IS_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_IS_LOADING', false)
          if (error.response && error.response.data && error.response.data.message) {
            // eslint-disable-next-line no-undef
            UIkit.notification({
              message: error.response.data.message,
              status: 'danger',
              pos: 'top-right',
              timeout: 5000
            })
          }
          reject(error)
        })
    })
  },
  exportTopSpender({ commit }, payload) {
    commit('SET_IS_LOADING', true)
    return new Promise((resolve, reject) => {
      apiPostAuth(API_AUTOMATION_REPORT.TOP_SPENDER, payload)
        .then((response) => {
          commit('SET_IS_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_IS_LOADING', false)
          if (error.response && error.response.data && error.response.data.message) {
            // eslint-disable-next-line no-undef
            UIkit.notification({
              message: error.response.data.message,
              status: 'danger',
              pos: 'top-right',
              timeout: 5000
            })
          }
          reject(error)
        })
    })
  },
  getConsumerSegmentPreview({ commit }, payload) {
    commit('SET_IS_LOADING', true)
    return new Promise((resolve, reject) => {
      apiPostMultipartAuth(PREVIEW_AUTOMATION_REPORT.CONSUMER_SEGMENT, payload)
        .then((response) => {
          commit('SET_IS_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_IS_LOADING', false)
          if (error.response && error.response.data && error.response.data.message) {
            // eslint-disable-next-line no-undef
            UIkit.notification({
              message: error.response.data.message,
              status: 'danger',
              pos: 'top-right',
              timeout: 5000
            })
          }
          reject(error)
        })
    })
  },
  exportConsumerSegment({ commit }, payload) {
    commit('SET_IS_LOADING', true)
    return new Promise((resolve, reject) => {
      apiPostMultipartAuth(API_AUTOMATION_REPORT.CONSUMER_SEGMENT, payload)
        .then((response) => {
          commit('SET_IS_LOADING', false)
          resolve(response)
        })
        .catch((error) => {
          commit('SET_IS_LOADING', false)
          if (error.response && error.response.data && error.response.data.message) {
            // eslint-disable-next-line no-undef
            UIkit.notification({
              message: error.response.data.message,
              status: 'danger',
              pos: 'top-right',
              timeout: 5000
            })
          }
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
